import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type Marquee from './marquee.vue'


// 输入框
export const marqueeProps = buildProps({
  /*
  * @description 列数，当列为0时为单行滚动
  */
  column:{
    type: Number,
    default:0
  },
  direction:{
    type:[definePropType<'normal' | 'reverse'>(String),definePropType<(e:number) => 'normal' | 'reverse'>(Function)] ,
    default:'normal'
  },
  rotate:{
    type: Number,
    default:0
  },
  gradient:{
    type: Boolean,
    default:false
  },
  gradientColor:{
    type: String,
    default:'rgba(255, 255, 255, 1)'
  },
  gradientWidth:{
    type: Number,
    default:100
  },
  vertical:{
    type: Boolean,
    default:false
  },
  spacing:{
    type: Number,
    default:0
  },
  left:{
    type: String,
    default:'20%'
  },
  top:{
    type: String,
    default:'20%'
  }
} as const)

export const marqueeEmits = {
  complete: (e:boolean) => e,
  'loop-complete': (e:boolean) => e,  
  pause: (e:boolean) => e,
  resume: (e:boolean) => e,
} as const

export type MarqueeProps = ExtractPropTypes<typeof marqueeProps> // 输入框

export type MarqueeInstance = InstanceType<typeof Marquee> // 输入框